import { useState, useEffect } from 'react';
import PlansManagement from '@/components/admin/PlansManagement';
import { API } from '@/App';

export default function AdminPlansPage() {
  const [plans, setPlans] = useState({});
  const [userCounts, setUserCounts] = useState({});

  useEffect(() => {
    fetchPlans();
  }, []);

  const fetchPlans = async () => {
    const token = localStorage.getItem('token');
    try {
      const [plansRes, usersRes] = await Promise.all([
        fetch(`${API}/admin/plans`, { headers: { 'Authorization': `Bearer ${token}` } }),
        fetch(`${API}/admin/users`, { headers: { 'Authorization': `Bearer ${token}` } })
      ]);

      if (plansRes.ok) {
        setPlans(await plansRes.json());
      }

      if (usersRes.ok) {
        const users = await usersRes.json();
        const counts = users.reduce((acc, user) => {
          const plan = user.subscription_plan || 'free';
          acc[plan] = (acc[plan] || 0) + 1;
          return acc;
        }, {});
        setUserCounts(counts);
      }
    } catch (error) {
      console.error('Error fetching plans:', error);
    }
  };

  return <PlansManagement plans={plans} userCounts={userCounts} />;
}
